export const DEFAULT = "/";
export const YOU = "you";

export const DEFAULT_START_ROUTE = `${DEFAULT}${YOU}/profile/overview`;
